import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component, ElementRef, HostListener,
    Injectable,
    OnDestroy,
    OnInit, ViewChild,
    ViewEncapsulation
} from '@angular/core';

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import { CalendarOptions, DateSelectArg, EventClickArg, EventApi } from '@fullcalendar/angular';
import { INITIAL_EVENTS, createEventId } from './event-utils';
import {FormGroup} from "@angular/forms";
import {filter, first, takeUntil} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {EventDialogComponent} from "./dialog/eventDialog.component";
import {ReservationDataService} from "../services/reservationData.service";
import {Observable, Subject} from "rxjs";
import {ReservationData} from "../models/reservationData";
import {User as BaseUser} from "../models/user";
import {DatePipe} from "@angular/common";
import {ActivatedRoute, NavigationEnd, Router, RouterEvent} from "@angular/router";
import { fromEvent } from 'rxjs';
import { addDays, addMinutes, endOfWeek } from 'date-fns';
import { finalize } from 'rxjs/operators';

import {
    CalendarDateFormatter,
    CalendarEvent,
    CalendarEventTimesChangedEvent, CalendarEventTitleFormatter, CalendarView,
} from 'angular-calendar';

import { addHours, startOfDay } from 'date-fns';
import { User } from './day-view-scheduler.component';
import {UserService} from "../services";
import {Resource} from "../models/resource";
import {EventDetailsDialogComponent} from "./dialog/eventDetailsDialog.component";
import { differenceInMinutes, startOfHour } from 'date-fns';
import { CustomDateFormatter } from './custom-date-formatter.provider';
import {DateAdapter} from "@angular/material/core";
import {ExitWithoutSaveDialogComponent} from "./dialog/exitWithoutSaveDialog.component";
import {start} from "repl";
import {EmployeeScheduleService} from "../services/employeeSchedule.service";
import {EmployeeSchedule} from "../models/employeeSchedule";
import {CalendarBadResponse} from "../models/calendarBadResponse";
import {GroupActivity} from "../models/groupActivity";

function floorToNearest(amount: number, precision: number) {
    return Math.floor(amount / precision) * precision;
}

function ceilToNearest(amount: number, precision: number) {
    return Math.ceil(amount / precision) * precision;
}

@Injectable()
export class CustomEventTitleFormatter extends CalendarEventTitleFormatter {
    weekTooltip(event: CalendarEvent, title: string) {
        if (!event.meta.tmpEvent) {
            return super.weekTooltip(event, title);
        }
    }

    dayTooltip(event: CalendarEvent, title: string) {
        if (!event.meta.tmpEvent) {
            return super.dayTooltip(event, title);
        }
    }
}

@Component({
    selector: 'mwl-demo-component',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss', ],
    providers: [
        DatePipe,
        {
            provide: CalendarEventTitleFormatter,
            useClass: CustomEventTitleFormatter,
        },
        {
            provide: CalendarDateFormatter,
            useClass: CustomDateFormatter,
        },
    ],
    styles: [
        `
      .disable-hover {
        pointer-events: none;
      }
    `,
    ],
    encapsulation: ViewEncapsulation.None,
})
export class CalendarComponent implements OnDestroy, OnInit, AfterViewInit {
    title = 'app-calendar';
    calendarVisible = true;
    loading = false;
    loadingIndicator: boolean;
    reservations: ReservationData[];
    reorderable: boolean;
    myDate = new Date();
    timePeriod: string;
    calendarObjects: any;
    dialogRef: any;
    confirmDialogRef: any;
    dragToCreateActive = false;
    weekStartsOn: 0 = 0;
    public destroyed = new Subject<any>();
    dayColumnWidth: any;
    processing: boolean = false;
    locale: string = 'pl';
    error: string = '';
    errorDetails: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    viewDate = new Date();
    users: User[] = [];
    resources: User[] = [];
    events: CalendarEvent[] = [];
    @ViewChild('scrollContainer') scrollContainer: ElementRef<HTMLElement>;
    view: CalendarView = CalendarView.Week;

    eventTimesChanged({
                          event,
                          newStart,
                          newEnd,
                      }: CalendarEventTimesChangedEvent): void {

        if (event.start.getTime() === newStart.getTime() && event.end.getTime() === newEnd.getTime()) {
            this.processing = true;
            this.reservationDataService.getById(event.id).pipe(first())
                .subscribe((reservation: ReservationData) => {
                        this.processing = false;
                        this.dialogRef = this._matDialog.open(EventDetailsDialogComponent, {
                            panelClass: 'contact-form-dialog',
                            data      : {
                                action : 'show',
                                event: reservation,
                                locale: this.locale,
                                services: event.meta.user.services,
                                service: event.meta.service,
                            },
                            width: '700px',
                        });

                        this.dialogRef.disableClose = true;
                        this.dialogRef.backdropClick().subscribe(_ => {
                            this.confirm();
                        });

                        this.dialogRef.afterClosed()
                            .subscribe((response: FormGroup) => {
                                this.processing = true;

                                if ( !response )
                                {
                                    this.loadEvents();
                                    this.events = [...this.events];
                                    this.refresh();
                                    this.processing = false;
                                    return;
                                }

                                reservation.startDate = response.getRawValue().date + ' ' + response.getRawValue().startHour + ':00';
                                reservation.endDate = response.getRawValue().date + ' ' + response.getRawValue().endHour + ':00';
                                reservation.description = response.getRawValue().description;
                                reservation.service = response.getRawValue().service;
                                reservation.reservedResources = response.getRawValue().reservedResources;

                                let uid = reservation.reservedUsers[0].id;

                                reservation.reservedUsers = [];
                                let u = new BaseUser();
                                u.id = uid;

                                reservation.reservedUsers.push(u);

                                for (let i=0; i<reservation.reservedResources.length;i++) {
                                    for (let j=0; j<this.users.length; j++) {
                                        if (reservation.reservedResources[i].id !== this.users[j].username) {
                                            continue;
                                        }

                                        let u = new BaseUser();
                                        u.id = this.users[j].id;
                                        reservation.reservedUsers.push(u);
                                    }
                                }

                                this.reservationDataService.update(reservation.id, reservation)
                                    .pipe(first())
                                    .subscribe(
                                        (data: ReservationData) => {
                                            this.processing = false;
                                            for (let i = 0; i < this.events.length; i++) {
                                                if (this.events[i].id === data.id) {
                                                    let user = null;

                                                    for (let j=0; j<this.users.length; j++) {
                                                        if (this.users[j].id !== data.reservedUsers[0].id) {
                                                            continue;
                                                        }

                                                        user = this.users[j];
                                                    }

                                                    let startHoursDiff = -1;
                                                    let endHoursDiff = -1;

                                                    let dateStart = new Date(data.startDate);
                                                    let dateEnd = new Date(data.endDate);

                                                    if (dateStart >= this.lastSunday(dateStart.getFullYear(), 3) && dateStart < this.lastSunday(dateStart.getFullYear(), 10) ) {
                                                        startHoursDiff = -2;
                                                    }

                                                    if (dateEnd >= this.lastSunday(dateEnd.getFullYear(), 3) && dateEnd < this.lastSunday(dateEnd.getFullYear(), 10)) {
                                                        endHoursDiff = -2;
                                                    }

                                                    this.events[i] = {
                                                        id: data.id,
                                                        title: this.formatDateToTitle(addHours(new Date(data.startDate), startHoursDiff), addHours(new Date(data.endDate), endHoursDiff)),
                                                        color: {
                                                            primary: data.groupActivity?'goldenrod':'',
                                                            secondary: data.groupActivity?'lightgoldenrodyellow':''
                                                        },
                                                        start: addHours(new Date(data.startDate), startHoursDiff),
                                                        end: addHours(new Date(data.endDate), endHoursDiff),
                                                        meta: {
                                                            user: user,
                                                            saved: true,
                                                            service: data.service,
                                                            customer: data.customer,
                                                            completed: data.completed,
                                                            groupActivity: data.groupActivity
                                                        },
                                                        resizable: {
                                                            beforeStart: true,
                                                            afterEnd: true,
                                                        },
                                                        draggable: true,
                                                    };
                                                    break;
                                                }
                                            }

                                            this.events = [...this.events];
                                            this.refresh();

                                            this.processing = false;
                                        },
                                        error => {
                                            this.processing = false;
                                            this.error = error;
                                        }
                                    );

                            }, (err) => {
                                console.log(err);
                            });

                        this.processing = false;
                    },
                    error => {
                        this.processing = false;
                    })

            return;
        }

        this.reservationDataService.updateDate(event.id, this._formatDatetime(newStart, 'yyyy-mm-dd hh:ii:ss'), this._formatDatetime(newEnd, 'yyyy-mm-dd hh:ii:ss'))
            .pipe(first())
            .subscribe(
                data => {

                },
                error => {

                }
            );


        event.start = newStart;
        event.end = newEnd;
        this.events = [...this.events];
    }

    userChanged({ event, newUser }) {
        event.color = newUser.color;
        event.meta.user = newUser;
        this.events = [...this.events];

        this.reservationDataService.updateUser(event.id, newUser.id)
            .pipe(first())
            .subscribe(
                data => {

                },
                error => {

                }
            );
    }

    constructor(
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private reservationDataService: ReservationDataService,
        private employeeScheduleService: EmployeeScheduleService,
        private datePipe: DatePipe,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        public _matDialog: MatDialog,
        private cdr: ChangeDetectorRef,
        private dateAdapter: DateAdapter<any>,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Calendar');

        this.dateAdapter.setLocale(this.locale);
    }

    ngAfterViewInit() {
        this.scrollToCurrentView();
    }

    viewChanged() {
        this.cdr.detectChanges();
        this.scrollToCurrentView();
    }

    private scrollToCurrentView() {
        if (this.view === CalendarView.Week || CalendarView.Day) {
            // each hour is 60px high, so to get the pixels to scroll it's just the amount of minutes since midnight
            const minutesSinceStartOfDay = differenceInMinutes(
                startOfHour(new Date()),
                startOfDay(new Date())
            );
            const headerHeight = this.view === CalendarView.Week ? 60 : 0;
            this.scrollContainer.nativeElement.scrollTop =
                minutesSinceStartOfDay + headerHeight;
        }
    }

    formatDateToTitle(dateFrom: any, dateTo: any): any {
        let title = '';
        let hf = dateFrom.getHours().toString();
        let mf = dateFrom.getMinutes().toString();

        let ht = dateTo.getHours().toString();
        let mt = dateTo.getMinutes().toString();

        if (hf.length === 1) {
            hf = "0" + hf;
        }

        if (mf.length === 1) {
            mf = "0" + mf;
        }

        if (ht.length === 1) {
            ht = "0" + ht;
        }

        if (mt.length === 1) {
            mt = "0" + mt;
        }

        title = hf + ':' + mf + ' - ' + ht + ':' + mt;

        return title;
    }

    startDragToCreate(
        {
            segment,
            segmentElement,
            user
        }
    ) {
        const dragToSelectEvent: CalendarEvent = {
            id: this.events.length,
            title: this.formatDateToTitle(segment.date, segment.date),
            start: segment.date,
            meta: {
                tmpEvent: true,
                saved: false,
                user: user,
            },
            resizable: {
                beforeStart: true, // this allows you to configure the sides the event is resizable from
                afterEnd: true,
            },
            draggable: true
        };

        this.events = [...this.events, dragToSelectEvent];
        const segmentPosition = segmentElement.getBoundingClientRect();
        this.dragToCreateActive = true;
        const endOfView = endOfWeek(this.viewDate, {
            weekStartsOn: this.weekStartsOn,
        });

        fromEvent(document, 'mousemove')
            .pipe(
                finalize(() => {
                    delete dragToSelectEvent.meta.tmpEvent;
                    this.dragToCreateActive = false;
                    this.refresh();
                    this.addEvent(dragToSelectEvent);
                }),
                takeUntil(fromEvent(document, 'mouseup'))
            )
            .subscribe((mouseMoveEvent: MouseEvent) => {
                const minutesDiff = ceilToNearest(
                    (mouseMoveEvent.clientY - segmentPosition.top),
                    30
                )/3;

                const daysDiff =
                    floorToNearest(
                        mouseMoveEvent.clientX - segmentPosition.left,
                        segmentPosition.width
                    ) / segmentPosition.width;

                const newEnd = addDays(addMinutes(segment.date, minutesDiff), daysDiff);

                if (newEnd > segment.date && newEnd < endOfView) {
                    dragToSelectEvent.end = newEnd;
                    dragToSelectEvent.title = this.formatDateToTitle(segment.date, newEnd);
                }
                this.refresh();
            });
    }

    private refresh() {
        this.events = [...this.events];
        this.cdr.detectChanges();
    }

    checkUser(event: any): void {
        for (let i=0; i<this.users.length; i++) {
            if (this.users[i].id === event.currentTarget.value) {
                this.users[i].visible = event.currentTarget.checked;
                break;
            }
        }

        this.users = [...this.users];
    }

    lastSunday(year, month) {
        var date = new Date(year,month,1,12);
        let weekday = date.getDay();
        let dayDiff = weekday===0 ? 7 : weekday;
        let lastSunday = date.setDate(date.getDate() - dayDiff);
        return date;
    }

    loadEvents() {
        this.events = [];
        this.reservationDataService.getByDate(this.datePipe.transform(this.viewDate, 'yyyy-MM-dd') + ' 00:00:00', this.datePipe.transform(this.viewDate, 'yyyy-MM-dd') + ' 23:59:59')
            .pipe(first())
            .subscribe((reservations: ReservationData[]) => {
                    for (let i = 0; i < reservations.length; i++) {

                        for (let k=0; k<reservations[i].reservedUsers.length; k++) {
                            let user = null;

                            for (let j = 0; j < this.users.length; j++) {
                                if (this.users[j].id !== reservations[i].reservedUsers[k].id) {
                                    continue;
                                }

                                user = this.users[j];

                                this.users[j].events.push(reservations[i]);
                            }

                            let startHoursDiff = -1;
                            let endHoursDiff = -1;
                            let dateStart = new Date(reservations[i].startDate);
                            let dateEnd = new Date(reservations[i].endDate);

                            if (dateStart >= this.lastSunday(dateStart.getFullYear(), 3) && dateStart < this.lastSunday(dateStart.getFullYear(), 10) ) {
                                startHoursDiff = -2;
                            }

                            if (dateEnd >= this.lastSunday(dateEnd.getFullYear(), 3) && dateEnd < this.lastSunday(dateEnd.getFullYear(), 10)) {
                                endHoursDiff = -2;
                            }

                            this.events.push(
                                {
                                    id: reservations[i].id,
                                    title: this.formatDateToTitle(addHours(new Date(reservations[i].startDate), startHoursDiff), addHours(new Date(reservations[i].endDate), endHoursDiff)),
                                    color: {
                                        primary: reservations[i].groupActivity?'goldenrod':'',
                                        secondary: reservations[i].groupActivity?'lightgoldenrodyellow':''
                                    },
                                    start: addHours(new Date(reservations[i].startDate), startHoursDiff),
                                    end: addHours(new Date(reservations[i].endDate), endHoursDiff),
                                    meta: {
                                        user: user,
                                        saved: true,
                                        service: reservations[i].service,
                                        customer: reservations[i].customer,
                                        completed: reservations[i].completed,
                                        groupActivity: reservations[i].groupActivity,
                                    },
                                    resizable: {
                                        beforeStart: true,
                                        afterEnd: true,
                                    },
                                    draggable: true,
                                }
                            );
                        }
                    }

                    this.refresh();
                },
                error => {

                });
    }

    ngOnInit() {

        for (let i=0; i<this.route.snapshot.data.workers.items.length; i++) {
            this.users.push({
                id: this.route.snapshot.data.workers.items[i].id,
                name: this.route.snapshot.data.workers.items[i].firstName + ' ' + this.route.snapshot.data.workers.items[i].lastName,
                username: this.route.snapshot.data.workers.items[i].username,
                color: {primary: '', secondary: ''},
                visible: false,
                isResource: false,
                events: [],
                services: this.route.snapshot.data.workers.items[i].services,
                employeeSchedules: [],
                availableHours: []
            });
        }

        for (let i=0; i<this.route.snapshot.data.resources.items.length; i++) {
            let visible = false;

            if (this.route.snapshot.data.resources.items[i].alwaysActiveInCalendar) {
                visible = true;
            }

            this.users.push({
                id: this.route.snapshot.data.resources.items[i].id,
                name: this.route.snapshot.data.resources.items[i].firstName,
                username: this.route.snapshot.data.resources.items[i].username,
                color: {primary:'', secondary: ''},
                visible: visible,
                isResource: true,
                events: [],
                services: [],
                employeeSchedules: [],
                availableHours: []
            });
        }

        this.users = [...this.users];

        for (let i=0; i<this.route.snapshot.data.workers.items.length; i++) {
            this.employeeScheduleService.getByDateAndUser(this.route.snapshot.data.workers.items[i].id, this.datePipe.transform(this.myDate, 'yyyy-MM-dd') + ' 00:00:00', this.datePipe.transform(this.myDate, 'yyyy-MM-dd') + ' 23:59:59').pipe(first())
                .subscribe((schedules: EmployeeSchedule[]) => {
                        if (schedules.length>0) {
                            for (let j = 0; j < this.users.length; j++) {
                                if (this.users[j].id !== this.route.snapshot.data.workers.items[i].id) {
                                    continue;
                                }

                                this.users[j].visible = true;
                                this.users[j].employeeSchedules = schedules;

                                for (let k=0; k<schedules.length; k++) {
                                    for (let l=this.convertDateToUTC(new Date(schedules[k].startDate)); l<=this.convertDateToUTC(new Date(schedules[k].endDate)); l = addMinutes(l, 10)) {
                                        let hour;

                                        if (l.getHours().toString().length === 1) {
                                            hour = '0' + l.getHours().toString();
                                        } else {
                                            hour = l.getHours().toString();
                                        }

                                        if (l.getMinutes().toString().length === 1) {
                                            hour += ':' + '0' + l.getMinutes().toString();
                                        } else {
                                            hour += ':' + l.getMinutes().toString();
                                        }

                                        this.users[j].availableHours.push(l.getHours().toString() + l.getMinutes().toString());
                                    }
                                }

                                break;
                            }

                            this.users = [...this.users];
                            this.cdr.detectChanges();
                        }
                    },
                    error => {

                    })
        }

        this.loadEvents();
        this.timePeriod = this.route.snapshot.params['timePeriod'];

        if (!this.timePeriod) {
            this.componentTitleService.addPart('Today');

            this.reservationDataService.getByDate(this.datePipe.transform(this.myDate, 'yyyy-MM-dd') + ' 00:00:00', this.datePipe.transform(this.myDate, 'yyyy-MM-dd') + ' 23:59:59').pipe(first())
                .subscribe(res => {
                        this.reservations = res;
                        this.loadingIndicator = false;
                    },
                    error => {

                    })
        } else if (this.timePeriod == 'tomorrow') {
            this.componentTitleService.addPart('Tomorrow');

            let currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
            let day = currentDate.getDate().toString();
            let month = (currentDate.getMonth() + 1).toString();
            let year = currentDate.getFullYear();

            if (day.length == 1) {
                day = '0' + day;
            }

            if (month.length == 1) {
                month = '0' + month;
            }

            this.reservationDataService.getByDate(year + '-' + month + '-' + day + ' 00:00:00', year + '-' + month + '-' + day + ' 23:59:59').pipe(first())
                .subscribe(res => {
                        this.reservations = res;
                        this.loadingIndicator = false;
                    },
                    error => {

                    })
        } else if (this.timePeriod == '7-days') {
            this.componentTitleService.addPart('7 days');

            let currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
            let day = (currentDate.getDate()-1).toString();
            let month = (currentDate.getMonth() + 1).toString();
            let year = currentDate.getFullYear();

            let date7 = new Date(new Date().getTime() + 6*24 * 60 * 60 * 1000);
            let day7 = date7.getDate().toString();
            let month7 = (date7.getMonth() + 1).toString();
            let year7 = date7.getFullYear();

            if (day.length == 1) {
                day = '0' + day;
            }

            if (month.length == 1) {
                month = '0' + month;
            }

            if (day7.length == 1) {
                day7 = '0' + month7;
            }

            if (month7.length == 1) {
                month7 = '0' + month7;
            }

            this.reservationDataService.getByDate(year + '-' + month + '-' + day + ' 00:00:00', year7 + '-' + month7 + '-' + day7 + ' 23:59:59').pipe(first())
                .subscribe(res => {
                        this.reservations = res;
                        this.loadingIndicator = false;
                    },
                    error => {

                    })
        } else if (this.timePeriod == 'month') {
            this.componentTitleService.addPart('Month');

            let currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
            let day = (currentDate.getDate()-1).toString();
            let month = (currentDate.getMonth() + 1).toString();
            let year = currentDate.getFullYear();

            let date7 = new Date(new Date().getTime() + 30*24 * 60 * 60 * 1000);
            let day7 = date7.getDate().toString();
            let month7 = (date7.getMonth() + 1).toString();
            let year7 = date7.getFullYear();

            if (day.length == 1) {
                day = '0' + day;
            }

            if (month.length == 1) {
                month = '0' + month;
            }

            if (day7.length == 1) {
                day7 = '0' + month7;
            }

            if (month7.length == 1) {
                month7 = '0' + month7;
            }

            this.reservationDataService.getByDate(year + '-' + month + '-' + day + ' 00:00:00', year7 + '-' + month7 + '-' + day7 + ' 23:59:59').pipe(first())
                .subscribe(res => {
                        this.reservations = res;
                        this.loadingIndicator = false;
                    },
                    error => {

                    })
        } else if (this.timePeriod == 'year') {
            this.componentTitleService.addPart('Year');

            let currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
            let day = (currentDate.getDate()-1).toString();
            let month = (currentDate.getMonth() + 1).toString();
            let year = currentDate.getFullYear();

            let date7 = new Date(new Date().getTime() + 365*24 * 60 * 60 * 1000);
            let day7 = date7.getDate().toString();
            let month7 = (date7.getMonth() + 1).toString();
            let year7 = date7.getFullYear();

            if (day.length == 1) {
                day = '0' + day;
            }

            if (month.length == 1) {
                month = '0' + month;
            }

            if (day7.length == 1) {
                day7 = '0' + month7;
            }

            if (month7.length == 1) {
                month7 = '0' + month7;
            }

            this.reservationDataService.getByDate(year + '-' + month + '-' + day + ' 00:00:00', year7 + '-' + month7 + '-' + day7 + ' 23:59:59').pipe(first())
                .subscribe(res => {
                        this.reservations = res;
                        this.loadingIndicator = false;
                    },
                    error => {

                    })
        }
    }

    convertDateToUTC(date): Date {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this.destroyed.next();
        this.destroyed.complete();
    }

    currentEvents: EventApi[] = [];

    displayInvisible() {
        for (let i=0; i<this.users.length; i++) {
            this.users[i].visible = !this.users[i].visible;
        }

        this.users = [...this.users];
    }

    handleDateSelect(selectInfo: DateSelectArg) {
        const title = prompt('Please enter a new title for your event');
        const calendarApi = selectInfo.view.calendar;

        calendarApi.unselect(); // clear date selection

        if (title) {
            calendarApi.addEvent({
                id: createEventId(),
                title,
                start: selectInfo.startStr,
                end: selectInfo.endStr,
                allDay: selectInfo.allDay
            });
        }
    }

    hourClicked(event: any) {
        // event.color = newUser.color;
        // event.meta.user = newUser;
        // this.events = [...this.events];

        console.log('hour changed');
        console.log(event);
        // this.addEvent();
        // console.log(newUser);
    }

    userClicked(event: any) {
        // event.color = newUser.color;
        // event.meta.user = newUser;
        // this.events = [...this.events];

        console.log('user clicked');
        // console.log(event);
        // console.log(newUser);
    }

    eventClicked({ event }: { event: CalendarEvent }): void {
        this.processing = true;
        this.reservationDataService.getById(event.id).pipe(first())
            .subscribe((reservation: ReservationData) => {
                    this.processing = false;
                    this.dialogRef = this._matDialog.open(EventDetailsDialogComponent, {
                        panelClass: 'contact-form-dialog',
                        data      : {
                            action : 'show',
                            event: reservation,
                            locale: this.locale,
                            services: event.meta.user.services,
                            service: event.meta.service,
                        },
                        width: '700px',
                    });

                    this.dialogRef.disableClose = true;
                    this.dialogRef.backdropClick().subscribe(_ => {
                        this.confirm();
                    });

                this.dialogRef.afterClosed()
                    .subscribe((response: FormGroup) => {
                        this.processing = true;

                        if ( !response )
                        {
                            this.loadEvents();
                            this.events = [...this.events];
                            this.refresh();
                            this.processing = false;
                            return;
                        }

                        reservation.startDate = response.getRawValue().date + ' ' + response.getRawValue().startHour + ':00';
                        reservation.endDate = response.getRawValue().date + ' ' + response.getRawValue().endHour + ':00';
                        reservation.description = response.getRawValue().description;
                        reservation.service = response.getRawValue().service;
                        reservation.reservedResources = response.getRawValue().reservedResources;

                        let uid = reservation.reservedUsers[0].id;

                        reservation.reservedUsers = [];
                        let u = new BaseUser();
                        u.id = uid;

                        reservation.reservedUsers.push(u);

                        for (let i=0; i<reservation.reservedResources.length;i++) {
                            for (let j=0; j<this.users.length; j++) {
                                if (reservation.reservedResources[i].id !== this.users[j].username) {
                                    continue;
                                }

                                let u = new BaseUser();
                                u.id = this.users[j].id;
                                reservation.reservedUsers.push(u);
                            }
                        }

                        this.reservationDataService.update(reservation.id, reservation)
                            .pipe(first())
                            .subscribe(
                                (data: ReservationData) => {
                                    this.processing = false;
                                    for (let i = 0; i < this.events.length; i++) {
                                        if (this.events[i].id === data.id) {
                                            let user = null;

                                            for (let j=0; j<this.users.length; j++) {
                                                if (this.users[j].id !== data.reservedUsers[0].id) {
                                                    continue;
                                                }

                                                user = this.users[j];
                                            }

                                            let startHoursDiff = -1;
                                            let endHoursDiff = -1;

                                            let dateStart = new Date(data.startDate);
                                            let dateEnd = new Date(data.endDate);

                                            if (dateStart >= this.lastSunday(dateStart.getFullYear(), 3) && dateStart < this.lastSunday(dateStart.getFullYear(), 10) ) {
                                                startHoursDiff = -2;
                                            }

                                            if (dateEnd >= this.lastSunday(dateEnd.getFullYear(), 3) && dateEnd < this.lastSunday(dateEnd.getFullYear(), 10)) {
                                                endHoursDiff = -2;
                                            }

                                            this.events[i] = {
                                                id: data.id,
                                                title: this.formatDateToTitle(addHours(new Date(data.startDate), startHoursDiff), addHours(new Date(data.endDate), endHoursDiff)),
                                                color: {
                                                    primary: data.groupActivity?'goldenrod':'',
                                                    secondary: data.groupActivity?'lightgoldenrodyellow':''
                                                },
                                                start: addHours(new Date(data.startDate), startHoursDiff),
                                                end: addHours(new Date(data.endDate), endHoursDiff),
                                                meta: {
                                                    user: user,
                                                    saved: true,
                                                    service: data.service,
                                                    customer: data.customer,
                                                    completed: data.completed,
                                                    groupActivity: data.groupActivity
                                                },
                                                resizable: {
                                                    beforeStart: true,
                                                    afterEnd: true,
                                                },
                                                draggable: true,
                                            };
                                            break;
                                        }
                                    }

                                    this.events = [...this.events];
                                    this.refresh();

                                    this.processing = false;
                                },
                                error => {
                                    this.processing = false;
                                    this.error = error;
                                }
                            );

                    }, (err) => {
                        console.log(err);
                    });

                    this.processing = false;
                },
                error => {
                    this.processing = false;
                })
    }

    changeDate(event: any) {
        this.viewDate = new Date(event);

        for (let i=0; i<this.route.snapshot.data.workers.items.length; i++) {
            this.users[i].visible = false;
            this.users[i].employeeSchedules = [];
            this.users[i].availableHours = [];
        }

        this.users = [...this.users];

        for (let i=0; i<this.route.snapshot.data.workers.items.length; i++) {
            this.employeeScheduleService.getByDateAndUser(this.route.snapshot.data.workers.items[i].id, this.datePipe.transform(this.viewDate, 'yyyy-MM-dd') + ' 00:00:00', this.datePipe.transform(this.viewDate, 'yyyy-MM-dd') + ' 23:59:59').pipe(first())
                .subscribe((schedules: EmployeeSchedule[]) => {
                        if (schedules.length>0) {
                            for (let j = 0; j < this.users.length; j++) {
                                if (this.users[j].id !== this.route.snapshot.data.workers.items[i].id) {
                                    continue;
                                }

                                this.users[j].visible = true;
                                this.users[j].employeeSchedules = schedules;

                                for (let k=0; k<schedules.length; k++) {
                                    for (let l=this.convertDateToUTC(new Date(schedules[k].startDate)); l<=this.convertDateToUTC(new Date(schedules[k].endDate)); l = addMinutes(l, 10)) {
                                        let hour;

                                        if (l.getHours().toString().length === 1) {
                                            hour = '0' + l.getHours().toString();
                                        } else {
                                            hour = l.getHours().toString();
                                        }

                                        if (l.getMinutes().toString().length === 1) {
                                            hour += ':' + '0' + l.getMinutes().toString();
                                        } else {
                                            hour += ':' + l.getMinutes().toString();
                                        }

                                        this.users[j].availableHours.push(l.getHours().toString() + l.getMinutes().toString());
                                    }
                                }

                                break;
                            }

                            this.users = [...this.users];
                            this.cdr.detectChanges();
                        }
                    },
                    error => {

                    })
        }

        this.loadEvents();
    }

    _formatDatetime(date: Date, format: string) {
        const _padStart = (value: number): string => value.toString().padStart(2, '0');
        return format
            .replace(/yyyy/g, _padStart(date.getFullYear()))
            .replace(/dd/g, _padStart(date.getDate()))
            .replace(/mm/g, _padStart(date.getMonth() + 1))
            .replace(/hh/g, _padStart(date.getHours()))
            .replace(/ii/g, _padStart(date.getMinutes()))
            .replace(/ss/g, _padStart(date.getSeconds()));
    }

    @HostListener('window:keyup.esc') onKeyUp() {
        this.confirm();
    }

    @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
        console.log('event:', event);
        event.returnValue = false;
    }

    private confirm() {
        this.confirmDialogRef = this._matDialog.open(ExitWithoutSaveDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'new',
                event: this.event,
            },
            width: '400px',
        });

        this.confirmDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.dialogRef.close();
            }, (err) => {
                console.log(err);
            });
    }

    private event: any;

    public addEvent(event: any) {
        this.event = event;
        this.dialogRef = this._matDialog.open(EventDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'new',
                event: event,
                worker: event.meta.user,
                locale: this.locale,
            },
            width: '700px',
        });

        this.dialogRef.disableClose = true;
        this.dialogRef.backdropClick().subscribe(_ => {
            this.confirm();
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                this.processing = true;

                if ( !response )
                {
                    for (let i = 0; i < this.events.length; i++) {
                        if (!this.events[i].meta.saved) {
                            this.events.splice(i, 1);
                            break;
                        }
                    }

                    this.events = [...this.events];
                    this.refresh();
                    this.processing = false;
                    return;
                }

                let reservationData = response.getRawValue();

                if (!event.end) {
                    event.end = new Date(event.start.getTime() + 10*60000);
                }

                reservationData.startDate = this._formatDatetime(event.start, 'yyyy-mm-dd hh:ii:ss');
                reservationData.endDate = this._formatDatetime(event.end, 'yyyy-mm-dd hh:ii:ss');
                reservationData.reservedUsers = [];
                reservationData.reservedUsers.push({'id': event.meta.user.id});

                for (let i=0; i<reservationData.reservedResources.length;i++) {
                    for (let j=0; j<this.users.length; j++) {
                        if (reservationData.reservedResources[i].id !== this.users[j].username) {
                            continue;
                        }

                        reservationData.reservedUsers.push({'id': this.users[j].id});
                    }
                }

                if (reservationData.customer) {
                    reservationData.customer = reservationData.customer.id;
                }

                if (reservationData.isGroupActivity) {
                    reservationData.groupActivity = new GroupActivity();
                    reservationData.groupActivity.trainer = reservationData.trainer;
                }

                this.reservationDataService.create(reservationData)
                    .pipe(first())
                    .subscribe(
                        (data: ReservationData) => {
                            for (let i = 0; i < this.events.length; i++) {
                                if (!this.events[i].meta.saved) {
                                    let user = null;

                                    for (let j=0; j<this.users.length; j++) {
                                        if (this.users[j].id !== data.reservedUsers[0].id) {
                                            continue;
                                        }

                                        user = this.users[j];

                                        this.users[j].events.push(data);
                                    }

                                    let startHoursDiff = -1;
                                    let endHoursDiff = -1;

                                    let dateStart = new Date(data.startDate);
                                    let dateEnd = new Date(data.endDate);

                                    if (dateStart >= this.lastSunday(dateStart.getFullYear(), 3) && dateStart < this.lastSunday(dateStart.getFullYear(), 10) ) {
                                        startHoursDiff = -2;
                                    }

                                    if (dateEnd >= this.lastSunday(dateEnd.getFullYear(), 3) && dateEnd < this.lastSunday(dateEnd.getFullYear(), 10)) {
                                        endHoursDiff = -2;
                                    }

                                    this.events[i] = {
                                        id: data.id,
                                        title: this.formatDateToTitle(addHours(new Date(data.startDate), startHoursDiff), addHours(new Date(data.endDate), endHoursDiff)),
                                        color: {
                                            primary: data.groupActivity?'goldenrod':'',
                                            secondary: data.groupActivity?'lightgoldenrodyellow':''
                                        },
                                        start: addHours(new Date(data.startDate), startHoursDiff),
                                        end: addHours(new Date(data.endDate), endHoursDiff),
                                        meta: {
                                            user: user,
                                            saved: true,
                                            service: data.service,
                                            customer: data.customer,
                                            completed: data.completed,
                                            groupActivity: data.groupActivity
                                        },
                                        resizable: {
                                            beforeStart: true,
                                            afterEnd: true,
                                        },
                                        draggable: true,
                                    };
                                    break;
                                }
                            }

                            this.events = [...this.events];
                            this.refresh();

                            this.processing = false;
                        },
                        error => {
                            this.processing = false;

                            this.error = error;
                        }
                    );

            }, (err) => {
                console.log(err);
            });
    }

    onNewItemEvent(value: any) {
        console.log(value);
        console.log(1);
    }

    onNewItemEvented(value: any) {
        console.log(value);
        console.log(2);
    }
}
